/**
 * @author omriha
 * 05/02/2020
 */
import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import queryString from 'query-string';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useEditorDimensions} from '../../../utils/hooks';
import LabelContainer from '../../../components/Page/LabelContainer';
import SMCEditor from '../../../components/Editor';
import {useServiceDomainEditor} from './ServiceDomainEditorHelper';
import RouteLeavingGuard from '../../PopupPages/RouteLeavingGuard';
import {isAdminReadOnlySelector} from '../../../store/selectors/user.selectors';
import {SMCDisabledProvider} from '../../../components/Simple/SMCDisabledContext';
import VerifyButtonsContainer from "../VerifyButtonsContainer";


/**
 * High level element to fetch, edit and save service domain, all logic implemented inside.
 * @param {string} id Id of service domain to fetch from the server to edit
 */
function ServiceDomainEditor({
    navigateTo,
    urlParams,
    id,
    isAdminReadOnly
}) {
    const { editorWidth, editorHeight } = useEditorDimensions();

    let defaultPage = 'general';
    const queryParams = queryString.parse(urlParams);
    if (queryParams && queryParams['page']) {
        defaultPage = queryParams['page'];
    }

    const {
        serviceDomainObject,
        isObjectDirty,
        editorPages,
        helpId,
        isPageDataLoaded,
        isPageLoadFailed,
        isInnerPageLoading,
        chosenPageId,
        errorMessagesByPageList,
        onPageChange,
        setServiceDomainData,
        saveButtonOnClick,
        revertButtonOnClick,
        reloadPageData
    } = useServiceDomainEditor(id, defaultPage);
    
    // Data passed down to the editor pages
    const editorPageData = {
        serviceDomainObject,
        setEditorPageId: onPageChange,
        setServiceDomainData,
        isPageDataLoaded,
    }

    return (
        <>
        <RouteLeavingGuard when={isObjectDirty} />
        <SMCPage loading={!isPageDataLoaded} helpId={helpId}>

            <div className="ObjectEditor" style={{ width: editorWidth }}>
                {/* Header */}
                <div className="ObjectEditorHeader">
                    <LabelContainer label="Name:" value={id} />
                </div>
                <SMCDisabledProvider forceDisable={isAdminReadOnly}>
                    <SMCEditor
                        editorPageData={editorPageData}
                        height={editorHeight}
                        width={editorWidth}
                        errorListByPage={errorMessagesByPageList}
                        chosenPageId={chosenPageId}
                        onPageChange={onPageChange}
                        isPageLoaded={isPageDataLoaded && !isInnerPageLoading}
                        isPageLoadFailed={isPageLoadFailed}
                        reloadData={reloadPageData}
                        pages={editorPages}
                    />
                </SMCDisabledProvider>
            </div>
        </SMCPage>
            <VerifyButtonsContainer
                disabled={isAdminReadOnly || !isPageDataLoaded}
                onClickSaveButton={saveButtonOnClick}
                onClickCancelButton={revertButtonOnClick}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
    isAdminReadOnly: isAdminReadOnlySelector(state)
});

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDomainEditor);